import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
// Exchange rates cached in localStorage (non-sensitive public data)
const RATE_KEY = 'mitzva_exchange_rate';
const ILS_KEY = 'mitzva_exchange_rate_ils';
const RATE_TS_KEY = 'mitzva_exchange_rate_ts';
const CACHE_TTL = 3600000; // 1 hour

const readCached = () => {
  const usd = localStorage.getItem(RATE_KEY);
  const ils = localStorage.getItem(ILS_KEY);
  const ts = localStorage.getItem(RATE_TS_KEY);
  if (usd && ts && Date.now() - Number(ts) < CACHE_TTL) {
    return { usdRate: Number(usd), ilsRate: ils ? Number(ils) : 5.0 };
  }
  return { usdRate: 17.24, ilsRate: 5.0 };
};

export const useExchangeRate = () => {
  const [rates, setRates] = useState(readCached);

  useEffect(() => {
    const ts = localStorage.getItem(RATE_TS_KEY);
    const hasIls = localStorage.getItem(ILS_KEY);
    if (ts && hasIls && Date.now() - Number(ts) < CACHE_TTL) return;

    fetch(`${API_URL}/api/exchange-rate`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data?.mxn_to_usd) {
          const next = { usdRate: data.mxn_to_usd, ilsRate: data.mxn_to_ils || 5.0 };
          setRates(next);
          localStorage.setItem(RATE_KEY, String(next.usdRate));
          localStorage.setItem(ILS_KEY, String(next.ilsRate));
          localStorage.setItem(RATE_TS_KEY, String(Date.now()));
        }
      })
      .catch(() => {});
    // Mount-once fetch: module-level constants + stable setter.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return rates;
};
